import React from 'react';
import { CustomSVG } from '../../CustomSVG/CustomSVG';
import AWSSVG from '../../../assets/icons/clouds/aws.svg?raw';

export const AWSLogo = (props) => <CustomSVG svg={AWSSVG} preserveColors {...props} />;
